import { useContext, useEffect, useState } from "react";
import { ToastContext } from "../../../../contexts/ToastContext";
import { useParams } from "react-router-dom";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "../../../../components/ui/dialog";
import { AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "../../../../components/ui/alert-dialog";
import PaginationBar from "../../../../components/common/PaginationBar";
import apiProduto from "../../../../services/apis/apiProduto";

export default function ListaProdutos({
	atualizarLista,
	pesquisar,
	funcaoModalController,
	onClose
}) {
	const [form, setForm] = useState({
		nome: '',
	});

	const [produtos, setProdutos] = useState([]);
	const [idEditar, setIdEditar] = useState();
	const [itemRemovido, setItemRemovido] = useState();
	const [idRemover, setIdRemover] = useState();
	const [pagination, setPagination] = useState();
	const { page } = useParams();

	const funcaoModal = funcaoModalController.funcaoModal;

	const { erro, sucesso } = useContext(ToastContext);

	useEffect(() => {
		apiProduto.fetchApi(page ? page : 1).then((res) => {
			setProdutos(res.data.items);
			setPagination(res.data);
		});
	}, [page]);



	function limparInputs() {
		setForm({
		});
	}
	
	function deletar(id) {
		apiProduto
			.deleteApi(id)
			.then((res) => {
				atualizarLista();
				sucesso('Equipamento deletado com sucesso!');
			})
			.catch((error) => {
				console.error(error.message);
				erro('Erro ao deletar equipamento!');
			});
	}

	function enviar(e) {
		e.preventDefault();

		if (funcaoModal === 'Adicionar') {
			apiProduto
				.postApi(form)
				.then((res) => {
					limparInputs();
					sucesso('Equipamento adicionada com sucesso!');
					atualizarLista();
					onClose();
				})
				.catch((error) => {
					erro('Erro ao adicionar equipamento!');
					console.error(error.message);
				});
		} else if (funcaoModal === 'Editar') {
			apiProduto
				.putApi(idEditar, form)
				.then((res) => {
					limparInputs();
					atualizarLista();
					sucesso('Equipamento editado com sucesso!');
					onClose();
				})
				.catch((error) => {
					console.error(error.message);
					erro('Erro ao editar equipamento!');
				});
		}
	}

	return (
		<>
			<Dialog>
				<div className="w-full flex flex-col items-center mt-[40px] md:px-[200px]">
					<table className="w-full">
						<thead className="border-b w-full">
							<tr>
							<th className="text-[25px] pl-[10px] text-start">
									ID
								</th>
								<th className="text-[25px] pl-[10px] text-start">
									Nome
								</th>
							</tr>
						</thead>
						<tbody>
							{produtos.map(
								(equipamento, i) =>
									equipamento.nome
										.toUpperCase()
										.startsWith(
											pesquisar.toUpperCase()
										) && (
										<tr
											className="border-b hover:bg-gray-200 hover:bg-opacity-5"
											key={i}
										>
											<td className="pl-[10px] text-[20px]">
												{
													equipamento.id
												}
											</td>
											<td className="flex justify-between py-1">
												<span className="text-[20px] pl-[10px]">
													{
														equipamento.nome
													}
												</span>
												<span className="flex">
													<AlertDialogTrigger>
														<div
															onClick={async () => {																
																setForm({
																	nome: equipamento.nome,
																});
																setIdEditar(equipamento.id);
																funcaoModalController.setFuncaoModal(
																	'Editar'
																);
															}}
														>
															<i
																className="fa-solid fa-pen-to-square text-[18px] hover:text-lightBlue"
																title="Editar"
															></i>
														</div>
													</AlertDialogTrigger>
													<DialogTrigger>
														<div
															className="mx-2.5"
															onClick={() => {
																setItemRemovido(
																	equipamento.nome
																);
																setIdRemover(
																	equipamento.id
																);
															}}
														>
															<i
																className="fa-solid fa-trash text-[18px] hover:text-lightBlue"
																title="Deletar"
															></i>
														</div>
													</DialogTrigger>
												</span>
											</td>
										</tr>
									)
							)}
						</tbody>
					</table>
					{pagination !== undefined && (
						<PaginationBar pagination={pagination} />
					)}
				</div>

				<DialogContent>
					<DialogHeader>
						<DialogTitle>
							Excluir {itemRemovido}?
						</DialogTitle>
					</DialogHeader>
					<DialogDescription>
						Todos os dados associados com {itemRemovido}{' '}
						serão removidos.
					</DialogDescription>
					<DialogFooter>
						<div
							className="bg-red-600/70 py-2 px-4 rounded-md hover:bg-red-600 hover:cursor-pointer border-slate-800 border-2 transition-all duration-200 ease-in-out"
							onClick={() => deletar(idRemover)}
						>
							<DialogClose>Excluir</DialogClose>
						</div>
					</DialogFooter>
				</DialogContent>
			</Dialog>

			<AlertDialogContent>
				<form onSubmit={(e) => enviar(e)}>
					<AlertDialogHeader>
						<AlertDialogTitle>
							{funcaoModal} Produto
						</AlertDialogTitle>
					</AlertDialogHeader>
					<div className="w-full max-h-[500px] flex justify-around my-5 px-5 flex-wrap gap-5 overflow-y-auto scrollbar-thin scrollbar-track-primary scrollbar-thumb-darkaccent">
						{/* NOME */}
						<div className="flex flex-col justify-start">
							<label
								className="text-[18px] mb-2 pl-1"
								htmlFor="nome"
							>
								Nome
							</label>
							<input
								id="nome"
								name="nome"
								type="text"
								className="border-b text-[20px] p-1.5 bg-inputColor rounded-t-md w-[180px]"
								value={form.nome}
								onChange={(e) =>
									setForm({
										...form,
										nome: e.target.value,
									})
								}
								required
							/>
						</div>
						{/* <div className="flex flex-col justify-start">
							<label
								className="text-[18px] mb-2 pl-1"
								htmlFor="potenciaNominal"
							>
								Potência Nominal (CV)
							</label>
							<input
								id="potenciaNominal"
								name="potenciaNominal"
								type="number"
								placeholder="Potencia Nominal"
								className="border-b text-[20px] p-1.5 bg-inputColor rounded-t-md w-[180px]"
								value={potenciaNominal}
								onChange={(e) =>
									setPotenciaNominal(
										e.target.value
									)
								}
								required
							/>
						</div> */}
					</div>
					<AlertDialogFooter>
						<div className="flex w-full justify-end gap-x-4 p-4">
							<AlertDialogAction className="w-32">
								Confirmar
							</AlertDialogAction>
							<div onClick={onClose}>
								<AlertDialogCancel className="w-32">
									Cancelar
								</AlertDialogCancel>
							</div>
						</div>
					</AlertDialogFooter>
				</form>
			</AlertDialogContent>
		</>
	);
}